import { httpBatchLink } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";
import { TRPCRouter } from "@webapp/shared";
import { getStoredAuthToken } from "../auth";
import { API_ORIGIN, IS_STAGING } from "../deployEnv";
import { getViewAsId } from "@util/viewAs";

export const trpc = createTRPCReact<TRPCRouter>({});

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: `${API_ORIGIN}/trpc`,
      headers() {
        const authToken = getStoredAuthToken();
        if (!authToken) return {};

        return {
          Authorization: `Bearer ${authToken}`,
        };
      },
      fetch: (url, options) => {
        let modifiedUrl = url;

        // This is always true
        if (typeof url === "string") {
          const { view_as, view_as_team } = getViewAsId() ?? {};
          const urlObj = new URL(url);
          if (view_as) urlObj.searchParams.set("view_as", view_as);
          if (view_as_team)
            urlObj.searchParams.set("view_as_team", view_as_team);
          modifiedUrl = urlObj.toString();
        }

        return fetch(modifiedUrl, {
          ...options,
          // *.alchemypreview.com is protected by cloudflare access, which requires the CF cookie to be sent
          credentials: IS_STAGING ? "include" : undefined,
          // Send the page URL the fetch call was made from so backend sentry can see it
          referrerPolicy: "no-referrer-when-downgrade",
        });
      },
    }),
  ],
});
